import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/pro-xg-48-poe@2x.jpg";
import v3Image from "../../assets/Switching/ProfessionalXG/professionalXg48PoE.jpg";
import { type Product } from "../../types";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  poeAvailability,
  poeOutput,
  portCount,
  proAvSupport,
  uplinkSpeed,
} from "../properties";

export const professionalXg48PoE: Product = {
  id: "professionalXg48PoE",
  productTitle: "Pro XG 48 PoE",
  description: "professionalXg48PoE.description",
  storePathParts: {
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
    productSlug: "usw-pro-xg-48-poe",
  },
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/usw-pro-xg-48-poe`,
  ],
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 242,
    height: 120,
  },
  productListGroup: productListSwitchingProfessional,
  isNew: true,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 480 x 44 mm\n(17.4 x 18.9 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: {
        type: "string",
        value: "48 + 4 SFP28",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo10Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "string",
        value: "25 Gbps",
      },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "string",
        value: "PoE+++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "string",
        value: "1080 W",
      },
    },
    {
      propertyId: etherlighting.id,
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: proAvSupport.id,
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.dcPowerBackup",
      },
    },
    {
      propertyId: "mounting",
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
  ],
};
